import {
  useFindAllOperatingSystemsQuery,
  useFindAllSoftwareQuery,
  useFindOneSoftwareLinkQuery,
  useRemoveSoftwareLinkMutation,
} from '../../api/api-hooks';
import { Grid, TextField } from '@mui/material';
import ItemOptionsBar from '../../components/ItemOptionsBar';
import { nullStringCheck } from '../../utils/stringManipulation';
import { Item } from '../../utils/sharedTypes';
import { Autocomplete } from '@mui/material';
import { SoftwareLinksForm } from './linksTypes';
import useSoftwareLinksUpdater from './useSoftwareLinksUpdater';
import useSoftwareLinksCreator from './useSoftwareLinksCreator';
import { softwareLinksMiddleware, softwareLinksValidator } from './linksUtils';
import SoftwareTypeManagementButton from '../software-types/SoftwareTypeManagementButton';
import { useState } from 'react';

interface Props {
  selectedLinks: Item[];
  setSelectedLinks: React.Dispatch<React.SetStateAction<Item[]>>;
}

const addFormInitialState: SoftwareLinksForm = {
  name: undefined,
  link: undefined,
  software: null,
};

const SoftwareLinksOptionsBar = ({
  selectedLinks,
  setSelectedLinks,
}: Props) => {
  const [deleteLink] = useRemoveSoftwareLinkMutation();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const linkCreator = useSoftwareLinksCreator();
  const linkUpdater = useSoftwareLinksUpdater();
  const { data: software } = useFindAllSoftwareQuery({});
  const { data: operatingSystems } = useFindAllOperatingSystemsQuery({});
  if (software === undefined || operatingSystems === undefined) return null;
  return (
    <>
      <ItemOptionsBar
        selectedItems={selectedLinks}
        setSelectedItems={setSelectedLinks}
        handlerMiddleware={softwareLinksMiddleware}
        itemValidator={softwareLinksValidator}
        editModalOpen={editModalOpen}
        setEditModalOpen={setEditModalOpen}
        itemDeleter={deleteLink}
        itemName='Software Link'
        formInstructions='Name, Link, and Software Type are required.'
        addFormInitialState={addFormInitialState}
        dialogSize='sm'
        childrenCreator={(addFormState: SoftwareLinksForm, handler: any) => (
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <Autocomplete
                onChange={(event, value) => {
                  handler(event, value, 'software');
                }}
                value={addFormState.software}
                options={software}
                getOptionLabel={(software) => software.type}
                style={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Software'
                    variant='outlined'
                  />
                )}
              />
            </Grid>
            <Grid item>
              <SoftwareTypeManagementButton />
            </Grid>
            <Grid item>
              <TextField
                margin='dense'
                name='name'
                label='Link Name'
                fullWidth
                value={nullStringCheck(addFormState.name)}
                onChange={handler}
              />
            </Grid>
            <Grid item></Grid>
            <Grid item>
              <TextField
                margin='dense'
                name='link'
                label='Link'
                fullWidth
                value={nullStringCheck(addFormState.link)}
                onChange={handler}
              />
            </Grid>
          </Grid>
        )}
        itemCreator={linkCreator}
        itemGetter={useFindOneSoftwareLinkQuery}
        itemUpdater={linkUpdater}
      />
    </>
  );
};

export default SoftwareLinksOptionsBar;
